import React, { useEffect, useState } from 'react'
import { BAIDU_MAPS_API_KEY } from '@/constant/constant'

declare global {
    interface Window {
        BMapGL: any
        BMAP_NORMAL_MAP: any
        BMAP_SATELLITE_MAP: any
        BMAP_ANIMATION_BOUNCE: any
        initBaiduMap?: () => void
    }
}

let isLoading = false
let isLoaded = false
const callbacks: (() => void)[] = []

function loadBaiduMapScript(ak: string): Promise<void> {
    return new Promise((resolve, reject) => {
        if (isLoaded && window.BMapGL) {
            resolve()
            return
        }

        if (isLoading) {
            callbacks.push(() => resolve())
            return
        }

        isLoading = true

        window.initBaiduMap = () => {
            isLoaded = true
            isLoading = false
            resolve()
            callbacks.forEach(cb => cb())
            callbacks.length = 0
            delete window.initBaiduMap
        }

        const script = document.createElement('script')
        script.src = `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${ak}&callback=initBaiduMap`
        script.onerror = () => {
            isLoading = false
            reject(new Error('Failed to load Baidu Maps SDK'))
        }
        document.head.appendChild(script)
    })
}

interface BaiduMapLoaderProps {
    children: React.ReactNode
    loadingElement?: React.ReactNode
}

const BaiduMapLoader: React.FC<BaiduMapLoaderProps> = ({ children, loadingElement }) => {
    const [loaded, setLoaded] = useState(isLoaded && !!window.BMapGL)

    useEffect(() => {
        if (loaded) return

        loadBaiduMapScript(BAIDU_MAPS_API_KEY)
            .then(() => setLoaded(true))
            .catch(err => console.error('Baidu Maps load error:', err))
    }, [loaded])

    if (!loaded) {
        return <>{loadingElement || null}</>
    }

    return <>{children}</>
}

export default BaiduMapLoader
